import { LogService } from './log-service';

let transactionLogService = new LogService();

export { transactionLogService }